import styled from 'styled-components';

export const Background = styled.div`
  background-color: white;
`;
export const Container = styled.div``;